export default "__VITE_ASSET__DkRG6JdC__"